var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCertificate = function SvgCertificate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.667 1.513v2.754c0 .373 0 .56-.073.702a.67.67 0 0 1-.291.292c-.143.072-.33.072-.703.072H2.846m2.487 3.334h4.334M8.333 6h1.334m-2.39 8.667h-1.41c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108V5.333l4-4h3.466c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108v2.743"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#certificate_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M13.667 11a.665.665 0 0 0-.667-.667M13 13a2 2 0 1 0-1.982-1.731c.02.145.03.217.023.263a.3.3 0 0 1-.04.115c-.022.04-.062.08-.141.16l-1.704 1.704c-.057.057-.086.086-.107.12a.3.3 0 0 0-.04.096c-.009.038-.009.08-.009.16v.58c0 .186 0 .28.036.351a.33.33 0 0 0 .146.146c.071.036.165.036.351.036h.8v-.667H11v-.666h.667l.526-.527c.08-.08.12-.119.16-.142a.3.3 0 0 1 .115-.039c.046-.006.118.004.263.023Q12.863 13 13 13"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "certificate_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8h8v8H8z"
  })))));
};
export default SvgCertificate;